"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LegacyCombobox_1 = __importDefault(require("Common/LegacyCombobox/LegacyCombobox"));
var styles = __importStar(require("./MultiSelectCombobox.css"));
function MultiSelectCombobox(_a) {
    var e_1, _b;
    var entries = _a.entries, selectedValues = _a.selectedValues, setSelectedValues = _a.setSelectedValues, label = _a.label, placeholder = _a.placeholder, icon = _a.icon, notFoundMessage = _a.notFoundMessage, notFoundIcon = _a.notFoundIcon, errorMessage = _a.errorMessage, errorValues = _a.errorValues, disabled = _a.disabled, disabledReason = _a.disabledReason, inputDisabled = _a.inputDisabled, inputDisabledReason = _a.inputDisabledReason, renderNoResultsMessage = _a.renderNoResultsMessage;
    var availableEntries = [];
    var selectedEntries = new Map(selectedValues.map(function (value) { return [value, undefined]; }));
    try {
        for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
            var e = entries_1_1.value;
            if (selectedEntries.has(e.value)) {
                selectedEntries.set(e.value, e);
            }
            else {
                availableEntries.push(e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (entries_1_1 && !entries_1_1.done && (_b = entries_1.return)) _b.call(entries_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var entryHasIcon = function () {
        return availableEntries.some(function (e) { return !!e.labelIcon; });
    };
    function select(value) {
        setSelectedValues(selectedValues.concat(value));
    }
    function deselect(value) {
        setSelectedValues(selectedValues.filter(function (o) { return o !== value; }));
    }
    var renderEntry = function (entry) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxxs", align: "center" },
            react_1.default.createElement("div", { className: styles.comboboxEntryIcon }, entry.labelIcon),
            react_1.default.createElement("div", { className: styles.comboboxEntryLabel }, entry.label)));
    };
    var MaybeWithTooltip = function (_a) {
        var show = _a.show, children = _a.children, _b = _a.tooltipMessage, tooltipMessage = _b === void 0 ? "" : _b;
        if (show) {
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: tooltipMessage, size: kaleidoscope_1.TooltipSize.Large }, children));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    };
    return (react_1.default.createElement(MaybeWithTooltip, { show: !!disabled && !!disabledReason, tooltipMessage: disabledReason || "" },
        react_1.default.createElement("div", { onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs" },
                react_1.default.createElement(MaybeWithTooltip, { show: !!inputDisabled && !!inputDisabledReason, tooltipMessage: inputDisabledReason || "" },
                    react_1.default.createElement(LegacyCombobox_1.default, { autoStack: true, clearOnSelect: true, entries: availableEntries, renderNoResultsMessage: renderNoResultsMessage, renderEntry: entryHasIcon() ? renderEntry : undefined, label: label, placeholder: placeholder, onSelect: function (entry) {
                            select(entry.value);
                        }, size: kaleidoscope_1.TextInputSize.Medium, disabled: disabled || inputDisabled })),
                errorMessage ? (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.errorText }, errorMessage)) : null,
                react_1.default.createElement("div", { className: styles.selectedValues }, selectedValues.map(function (value) {
                    var _a;
                    var entry = selectedEntries.get(value);
                    if (entry) {
                        var selectionCard = (react_1.default.createElement(SelectionCard, { key: value, cardIcon: icon, value: value, label: { text: entry.label, icon: entry.labelIcon }, deselect: deselect, error: (_a = errorValues === null || errorValues === void 0 ? void 0 : errorValues.some(function (errorValue) { return errorValue === value; })) !== null && _a !== void 0 ? _a : false, disabled: disabled }));
                        if (entry.tooltip) {
                            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: entry.tooltip, size: kaleidoscope_1.TooltipSize.Small, className: styles.selectionCardTooltip }, selectionCard));
                        }
                        return selectionCard;
                    }
                    else if (notFoundMessage) {
                        return (react_1.default.createElement(SelectionCard, { key: value, cardIcon: icon, value: value, label: { text: notFoundMessage, icon: notFoundIcon }, deselect: deselect, error: true }));
                    }
                    else {
                        return null;
                    }
                }))))));
}
exports.default = MultiSelectCombobox;
var SelectionCard = function (_a) {
    var value = _a.value, label = _a.label, cardIcon = _a.cardIcon, deselect = _a.deselect, error = _a.error, disabled = _a.disabled;
    return (react_1.default.createElement("div", { className: styles.selectionCard({ error: error, disabled: disabled }) },
        !!cardIcon && react_1.default.createElement("div", { className: styles.selectionCardIcon }, cardIcon),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxxs", align: "center" },
            label.icon && react_1.default.createElement("div", { className: styles.selectionCardLabelIcon }, label.icon),
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.selectionCardLabelText, size: "s", strong: true }, label.text)),
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.selectionCardIcon, icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, onClick: function () { return deselect(value); }, disabled: disabled })));
};
